export const setRef = (ref: string | undefined, redirectUrl: string) => {
  let tempRedirectUrl = redirectUrl
  if (ref && !redirectUrl.includes('ref=')) {
    const separator = tempRedirectUrl.includes('?') ? '&' : '?'
    tempRedirectUrl = `${tempRedirectUrl}${separator}ref=${ref}`
  }
  return tempRedirectUrl
}
